
import * as React from 'react';

// components
import SiteHeader from '../layout/SiteHeader';

function IPIDPage() {
  return (
    <div className="">
      <SiteHeader hideLogout />
      {IPID()}
    </div>
  );
}

function IPID() {
  return (
      <div className="panel u-margin-y-medium">

        <div className="i-header">
          <h1>Furniture Insurance</h1>
          <h4>Insurance Product Information Document</h4>
          <h5>Company: Acasta European Insurance Company Limited Product: Furniture Care Policy</h5>
          <p>Acasta European Insurance Company Limited Registered Office: 5/5 Crutchett’s Ramp,  Gibraltar.  GX11  1AA.  Company  reg.  96218.  Acasta European Insurance Company Limited is authorised and regulated by the Gibraltar Financial Services Commission and subject to limited regulation by  the Financial  Conduct Authority  and  Prudential  Regulation Authority  for  the  conduct  of  UK  business  and  by  the  Central  Bank  of Ireland  in the Republic of Ireland.</p>
        </div>

        <section className="ipid">
          <p>Complete pre-contractual and contractual information on the insurance product is provided in the terms and conditions.</p>
          <h4>What is this type of insurance?</h4>
          <p>This insurance provides cover for staining and accidental damage. Where Recliner and Headrest Mechanism Top-Up is purchased, certain cover applies and commences upon expiry of the relevant manufacturers guarantee.</p>
        </section>

        <section id="i-panel--bundle">
          <article className="i-panel  whatsInsured">
            <summary><span className="i-icon  i-icon--insured"><i className="sa sa-umbrella"></i></span>What is insured?</summary>
            <ul className="i-parent">
              <li>
                <p><b>Accidental stains such as:</b></p>
                <ul className="i-ticks">
                  <li><i className="sa sa-tick"></i><p>Food</p></li>
                  <li><i className="sa sa-tick"></i><p>Drink</p></li>
                  <li><i className="sa sa-tick"></i><p>Bodily Fluids</p></li>
                  <li><i className="sa sa-tick"></i><p>Make-up and nail varnish</p></li>
                  <li><i className="sa sa-tick"></i><p>Dye Transfer</p></li>
                  <li><i className="sa sa-tick"></i><p>Any substance except mineral oils and soot</p></li>

                </ul>
              </li>
              <li>
                <p><b>Accidental damage resultin in:</b></p>
                <ul className="i-ticks">
                  <li><i className="sa sa-tick"></i><p>Rips and tears</p></li>
                  <li><i className="sa sa-tick"></i><p>Burns</p></li>
                  <li><i className="sa sa-tick"></i><p>Scratches, punctures or scuffs (leather products)</p></li>
                  <li><i className="sa sa-tick"></i><p>Pet scratches (one incident)</p></li>
                </ul>
              </li>
              <li>
                <p><b>Recliner and Headrest Mechanism Top-up Only:</b></p>
                <p>Associated with the mechanism:</p>
                <ul className="i-ticks">
                  <li><i className="sa sa-tick"></i> <p>Bending or breaking of any metal components</p></li>
                  <li><i className="sa sa-tick"></i> <p>Failure of any Electrical equipment</p></li>
                  <li><i className="sa sa-tick"></i> <p>Broken handles, buttons and snapped cables</p></li>
                  <li><i className="sa sa-tick"></i> <p>Consequential Damage to other product components directly linked to the failure of the mechanism</p></li>
                </ul>
              </li>
            </ul>

          </article>
          <aside className="i-panel  whatsNotInsured">
            <summary><span className="i-icon  i-icon--notInsured"><i className="sa sa-no-salesman"></i></span>What is not insured?</summary>
            <ul className="i-crosses">
              <li><i className="sa sa-times"></i><p>Wear and Tear</p></li>
              <li><i className="sa sa-times"></i><p>Deliberate damage, neglect, abuse or misuse</p></li>
              <li><i className="sa sa-times"></i><p>Changes in colour caused by sunlight, perspiration, natural hair and body oils</p></li>
              <li><i className="sa sa-times"></i><p>Stains caused by dye transfer unless resulting from sudden contact with clothing or newspaper and magazine print</p></li>
              <li><i className="sa sa-times"></i><p>The gradual accumulation of multiple stains</p></li>
              <li><i className="sa sa-times"></i><p>Damage to, and failure of, the mechanism as a direct result of the failure of other furniture components not covered by this policy</p></li>
              <li><i className="sa sa-times"></i><p>Structural defects</p></li>
              <li><i className="sa sa-times"></i><p>Commercial use</p></li>
            </ul>
          </aside>
          <div className="i-panel  restrictions">
            <summary><span className="i-icon  i-icon--restrictions"><i className="sa sa-warning"></i></span>Are there any restrictions on cover?</summary>
            <ul className="i-exclamation">
              <li><i className="sa sa-exclamation"></i><p>You must be a resident in the UK and ROI</p></li>
              <li><i className="sa sa-exclamation"></i><p>You must be at least 16 years old</p></li>
              <li><i className="sa sa-exclamation"></i><p>Product must be used for domestic purposes</p></li>
              <li><i className="sa sa-exclamation"></i><p>You cannot transfer this insurance to another person</p></li>
              <li><i className="sa sa-exclamation"></i><p>Pet damage and deliberate damage by a child are limited to only one incident each during the period of cover</p></li>
            </ul>
          </div>
        </section>

        <div className="i-panel  i-center">
          <summary><span className="i-icon  i-icon--whereCovered"><i className="sa sa-globe"></i></span>Where am I covered?</summary>
          <ul className="i-bluetick">
            <li><i className="sa sa-tick"></i><p>In the United Kingdom and Republic of Ireland</p></li>
          </ul>
        </div>

        <div className="i-panel  i-center">
          <summary><span className="i-icon  i-icon--whatObligations"><i className="sa sa-handshake-o"></i></span>What are my obligations?</summary>
          <ul>
            <li><p>To take all reasonable precautions to safeguard the product and to avoid loss or damage to it</p></li>
            <li><p>To maintain the product in accordance with the manufacturer's instructions</p></li>
            <li><p>To follow our claims procedure when making a claim as shown in your terms and conditions</p></li>
            <li><p>To supply accurate and complete answers to all the questions we may ask as part of your application for cover under the policy</p></li>
            <li><p>To register any claim within 72 hours of discovering the damage</p></li>
          </ul>
        </div>

        <div className="i-panel  i-center">
          <summary><span className="i-icon  i-icon--whenPay"><i className="sa sa-coins"></i></span>When and how do I pay?</summary>
          <p>You must pay the total premium in one full payment before the policy starts.</p>
        </div>

        <div className="i-panel  i-center">
          <summary><span className="i-icon  i-icon--whenCover"><i className="sa sa-clock"></i></span>When does the cover start and end?</summary>
          <p>Cover for staining and accidental damage starts from the date of delivery of the product. If purchased, the Recliner and Headrest Mechanism Top-Up cover starts from the expiry of the manufacturers guarantee. The date that the cover ends can be found on the front of your certificate of insurance.</p>
        </div>

        <div className="i-panel  i-center">
          <summary><span className="i-icon  i-icon--howCancel"><i className="sa sa-hand-paper-o"></i></span>How do I cancel the contract?</summary>
          <p>You can cancel this policy at any point, up to 14 days from receipt of your certificate of insurance, and receive a full refund. No refund of premium will be made if you have made a claim or if you cancel the policy after 14 days from receipt of your certificate of insurance. To cancel your policy please return to the retailer where you bought the product together with the sales receipt or invoice.</p>
        </div>
      </div>
  );
}
export default IPIDPage;



// WEBPACK FOOTER //
// ./src/pages/IPIDPage.js